import { allVaultsQueryParams } from '@/config/query/queryParams'
import { getDefiSdk } from '@/utils/defiSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { MINUTE_IN_MILLISECONDS } from '@vaultsfyi/common/constants'

export const vaultsQueryOptions = () => {
  return queryOptions({
    queryKey: ['vaults'] as const,
    async queryFn() {
      const defiSdk = getDefiSdk()
      return await defiSdk
        .getAllVaults({
          query: allVaultsQueryParams,
        })
        .then((data) => data.data)
    },
    select(data) {
      if (data == null) {
        return null
      }
      return data
    },
    retry: 2,
    staleTime: 30 * MINUTE_IN_MILLISECONDS,
    refetchInterval: 30 * MINUTE_IN_MILLISECONDS,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  })
}

export type VaultsQueryInitialData = ReturnType<typeof vaultsQueryOptions>['initialData']

export const useVaultsQuery = ({
  initialData,
}: {
  initialData: VaultsQueryInitialData
}) => {
  const { data, isFetching } = useQuery({
    ...vaultsQueryOptions(),
    initialData,
  })
  return { data, isFetching }
}
